import { ChangeEvent, FC, useCallback } from 'react';
import { useIntl } from 'react-intl';

type TraceReportingProps = Readonly<{ value: boolean; onValueChanged: (val: boolean) => void }>;

export const TraceReporting: FC<TraceReportingProps> = ({ value, onValueChanged }) => {
  const { formatMessage } = useIntl();
  const onChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onValueChanged(e.target.checked);
    },
    [onValueChanged],
  );

  return (
    <div className="px-2 py-1 border-start">
      <div className="form-check mx-2">
        <input
          id="enable-trace-reporting"
          type="checkbox"
          className="form-check-input"
          checked={value}
          onChange={onChange}
        />
        <label className="form-check-label" htmlFor="enable-trace-reporting">
          {formatMessage({ id: 'secondaryMarket.sidePanel.label.traceReporting' })}
        </label>
      </div>
      {value && (
        <div className="mt-3 border d-flex align-items-start text-warning">
          <div className="align-self-center ms-2 me-3">
            <em className="icon icon-sm">warning</em>
          </div>
          <div className="py-2">{formatMessage({ id: 'secondaryMarket.sidePanel.label.traceReportingWarning' })}</div>
        </div>
      )}
    </div>
  );
};
